import { createGeneralMediaQuery, mediaQueriesArray } from './createMediaQuery';
import type { ResponsiveGeneral, ResponsiveSpacing } from './types';

export const createResponsiveGeneralStyle = (cssProp: string, value: ResponsiveSpacing | ResponsiveGeneral<string>) => {
  if (typeof value === 'number' || typeof value === 'string') {
    return `${cssProp}: ${value}`;
  } else if (Array.isArray(value)) {
    return mediaQueriesArray(cssProp, value, createGeneralMediaQuery);
  }
  return null;
};
